/*
 *
 * UserEditPage reducer
 *
 */

import { fromJS } from "immutable";
import {
  DEFAULT_ACTION,
  GET_USER_SUCCESS_ACTION,
  CHANGE_PASSWORD_FAILED_ACTION,
  CHANGE_PASSWORD_ACTION,
  CHANGE_PASSWORD_SUCCESS_ACTION,
  LANGUAGE_SUCCESS_ACTION,
  CHANGE_USER_ACTION,
  CHANGE_USER_FAILED_ACTION,
  CHANGE_USER_SUCCESS_ACTION,
  GET_USER_ACTION,
  GET_PRACTICE_MESSAGES,
  GET_PRACTICE_MESSAGES_SUCCESS,
  GET_PRACTICE_MESSAGES_ERROR,
  CHANGE_PASS_RESET,
} from "./constants";

export const initialState = fromJS({
  user: null,
  passwordInProgress: false,
  passwordFailed: null,

  userInProgress: false,
  userFailed: null,

  languages: [],

  messages: [],
});

function userEditPageReducer(state = initialState, action) {
  switch (action.type) {
    case DEFAULT_ACTION:
      return state;

    case CHANGE_PASS_RESET:
      return state.set("passwordFailed", null);
    case CHANGE_PASSWORD_ACTION:
      return state.set("passwordInProgress", true);
    case CHANGE_PASSWORD_FAILED_ACTION:
      return state
        .set("passwordFailed", action.reason)
        .set("passwordInProgress", false);
    case CHANGE_PASSWORD_SUCCESS_ACTION:
      return state.set("passwordFailed", null).set("passwordInProgress", false);
    case GET_USER_ACTION:
      return state
        .set("userInProgress", true)
        .set("userFailed", null)
        .set("user", null);
    case GET_USER_SUCCESS_ACTION:
      return state.set("user", action.user).set("userInProgress", false);

    case LANGUAGE_SUCCESS_ACTION:
      return state.set("languages", fromJS(action.languages));
    case CHANGE_USER_ACTION:
      return state.set("userInProgress", true).set("userFailed", null);
    case CHANGE_USER_FAILED_ACTION:
      return state
        .set("userInProgress", false)
        .set("userFailed", action.reason);
    case CHANGE_USER_SUCCESS_ACTION:
      return state
        .set("userInProgress", false)
        .set("userFailed", null)
        .set("user", action.result);

    case GET_PRACTICE_MESSAGES:
      return state.set("messages", []);
    case GET_PRACTICE_MESSAGES_ERROR:
      return state.set("messages", []);
    case GET_PRACTICE_MESSAGES_SUCCESS:
      return state.set("messages", action.messages);
    default:
      return state;
  }
}

export default userEditPageReducer;
